import { transferToBrowserAction } from '../auth/TransferToBrowserAction.ts';
import { useSessionStore } from '@/stores/SessionStore.ts';
import { useUserInfoStore } from '@/stores/UserInfoStore.ts';
import { SubscriptionTier } from '@/types/SubscriptionTier.ts';
import { createTextToast } from '@/utils/ToastUtils.ts';
import { logger } from '@/lib/logger.ts';

export const openWebViewAction = async () => {
    const sessionStore = useSessionStore();
    if (sessionStore.isInsideWebView) {
        logger.debug(`openWebViewAction called from inside web view, ignoring...`);
        return;
    }

    const userInfoStore = useUserInfoStore();
    if (userInfoStore.subscriptionTier === SubscriptionTier.Trial) {
        createTextToast(
            'Web View is unavailable during trial.',
            'Subscribe to use the Leetcode Wizard web view.',
            'destructive',
            false,
        );

        return;
    }

    await transferToBrowserAction('/');
};
